import { combineReducers } from 'redux';

import productNotify from 'reducers/detail/sharing/productNotify';

export default combineReducers({
  productNotify
});
